import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { aosColor, TableColumn, IconComponent } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'aos-configured-column',
  imports: [IconComponent, TranslateModule],
  template: `
    <div class="f-center cell">
      @if (!data()) {
        <ui-icon
          [name]="'not-checked'"
          [color]="color.grayscale300"
        ></ui-icon>
      } @else {
        <ui-icon
          [name]="'checked'"
          [color]="color.primary500"
        ></ui-icon>
        <span> {{ configuredLabel | translate }}</span>
      }
    </div>
  `,
  styles: `
    @use 'variables' as *;
    .cell + .cell {
      margin-top: 0.5rem;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfiguredColumnComponent {
  item = input.required<{ [key: string]: boolean | null }>();
  column = input.required<TableColumn>();

  protected configuredLabel = TranslateRegistry.get.BASE_STATION_PROVISIONING.LABEL.CONFIGURED;

  protected readonly color = aosColor;
  protected data = computed(() => this.item()[this.column().field]);
}
